import gql from "graphql-tag"

export const ShopifyPricingPercentageFields = gql`
  fragment ShopifyPricingPercentageFields on PricingPercentageValue {
    percentage
  }
`

export const ShopifyMoneyV2Fields = gql`
  fragment ShopifyMoneyV2Fields on MoneyV2 {
    amount
    currencyCode
  }
`

export const ShopifyShippingRateFields = gql`
  ${ShopifyMoneyV2Fields}
  fragment ShopifyShippingRateFields on ShippingRate {
    title
    handle
    priceV2 {
      ...ShopifyMoneyV2Fields
    }
  }
`

export const ShopifyMailingAddressFields = gql`
  fragment ShopifyMailingAddressFields on MailingAddress {
    id
    firstName
    lastName
    company
    address1
    address2
    city
    country
    province
    zip
    phone
    formatted
  }
`

export const CartDeliveryAddressFields = gql`
  fragment CartDeliveryAddressFields on CartDeliveryAddress {
    address1
    address2
    city
    company
    countryCode
    firstName
    formatted
    lastName
    latitude
    longitude
    name
    phone
    provinceCode
    zip
  }
`

export const CheckoutUserErrorsFields = gql`
  fragment CheckoutUserErrorsFields on CheckoutUserError {
    code
    field
    message
  }
`

export const CartUserErrorFields = gql`
  fragment CartUserErrorFields on CartUserError {
    field
    message
    code
  }
`
export const ShopifyProductVariantFields = gql`
  ${ShopifyMoneyV2Fields}
  fragment ShopifyProductVariantFields on ProductVariant {
    id
    availableForSale
    compareAtPrice {
      ...ShopifyMoneyV2Fields
    }
    price {
      ...ShopifyMoneyV2Fields
    }
    sku
  }
`
export const ShopifyProductFields = gql`
  ${ShopifyProductVariantFields}
  fragment ShopifyProductFields on Product {
    id
    handle
    variants(first: 100) {
      edges {
        node {
          ...ShopifyProductVariantFields
        }
      }
    }
  }
`

export const CheckoutDiscountFields = gql`
  ${ShopifyPricingPercentageFields}
  ${ShopifyMoneyV2Fields}
  fragment CheckoutDiscountFields on DiscountApplication {
    allocationMethod
    targetSelection
    targetType
    value {
      ...ShopifyPricingPercentageFields
      ...ShopifyMoneyV2Fields
    }
  }
`

export const CartDiscountAllocationFields = gql`
  ${ShopifyPricingPercentageFields}
  ${ShopifyMoneyV2Fields}
  fragment CartDiscountAllocationFields on CartDiscountAllocation {
    discountApplication {
      value {
        ...ShopifyPricingPercentageFields
        ...ShopifyMoneyV2Fields
      }
      allocationMethod
      targetSelection
      targetType
    }
    discountedAmount {
      ...ShopifyMoneyV2Fields
    }
    targetType
  }
`

// export const CheckoutLineItemFieldsV1 = gql`
//   fragment CheckoutLineItemFields on CheckoutLineItem {
//     id
//     title
//     quantity
//     variant {
//       id
//       sku
//       product {
//         id
//       }
//     }
//     customAttributes {
//       key
//       value
//     }
//   }
// `

export const CartLineInputFields = gql`
  fragment CartLineInputFields on CartLineInput {
    merchandiseId
    quantity
    attributes {
      key
      value
    }
    sellingPlanId
  }
`

export const CheckoutLineItemFields = gql`
  ${ShopifyProductVariantFields}
  ${ShopifyMoneyV2Fields}
  fragment CheckoutLineItemFields on BaseCartLine {
    id
    quantity
    merchandise {
      ...ShopifyProductVariantFields
    }
    attributes {
      key
      value
    }
    cost {
      amountPerQuantity {
        ...ShopifyMoneyV2Fields
      }
      subtotalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalAmount {
        ...ShopifyMoneyV2Fields
      }
    }
    discountAllocations {
      discountedAmount {
        ...ShopifyMoneyV2Fields
      }
    }
  }
`

export const CheckoutFields = gql`
  ${ShopifyMoneyV2Fields}
  ${ShopifyShippingRateFields}
  ${ShopifyMailingAddressFields}
  ${CheckoutDiscountFields}
  ${CheckoutLineItemFields}
  fragment CheckoutFields on Checkout {
    id
    note
    webUrl
    completedAt
    order {
      shippingAddress {
        ...ShopifyMailingAddressFields
      }
    }
    shippingAddress {
      ...ShopifyMailingAddressFields
    }
    discountApplications(first: 100) {
      edges {
        node {
          ...CheckoutDiscountFields
        }
      }
    }
    lineItems(first: 100) {
      edges {
        node {
          ...CheckoutLineItemFields
        }
      }
    }
    lineItemsSubtotalPrice {
      ...ShopifyMoneyV2Fields
    }
    subtotalPriceV2 {
      ...ShopifyMoneyV2Fields
    }
    shippingLine {
      ...ShopifyShippingRateFields
    }
    totalTaxV2 {
      ...ShopifyMoneyV2Fields
    }
    totalPriceV2 {
      ...ShopifyMoneyV2Fields
    }
  }
`

export const CartLineFields = gql`
  ${ShopifyProductVariantFields}
  ${ShopifyMoneyV2Fields}
  fragment CartLineFields on CartLine {
    id
    quantity
    merchandise {
      ...ShopifyProductVariantFields
    }
    attributes {
      key
      value
    }
    cost {
      totalAmount {
        ...ShopifyMoneyV2Fields
      }
    }
  }
`

export const BaseCartLineFields = gql`
  ${ShopifyProductVariantFields}
  ${ShopifyMoneyV2Fields}
  fragment BaseCartLineFields on BaseCartLine {
    id
    quantity
    merchandise {
      ...ShopifyProductVariantFields
    }
    attributes {
      key
      value
    }
    cost {
      amountPerQuantity {
        ...ShopifyMoneyV2Fields
      }
      subtotalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalAmount {
        ...ShopifyMoneyV2Fields
      }
    }
  }
`

// export const ShopifyProductVariantFieldsV1 = gql`
//   ${ShopifyMoneyV2Fields}
//   fragment ShopifyProductVariantFields on ProductVariant {
//     id
//     availableForSale
//     compareAtPriceV2 {
//       ...ShopifyMoneyV2Fields
//     }
//     priceV2 {
//       ...ShopifyMoneyV2Fields
//     }
//   }
// `

export const OrderLineItemFields = gql`
  ${ShopifyMoneyV2Fields}
  fragment OrderLineItemFields on OrderLineItem {
    quantity
    variant {
      id
      sku
      priceV2 {
        ...ShopifyMoneyV2Fields
      }
      product {
        id
        title
      }
    }
    customAttributes {
      key
      value
    }
  }
`

export const CustomerUserErrorsFields = gql`
  fragment CustomerUserErrorsFields on CustomerUserError {
    code
    field
    message
  }
`

export const CartCustomerFields = gql`
  ${ShopifyMoneyV2Fields}
  ${ShopifyMailingAddressFields}
  ${CheckoutDiscountFields}
  ${OrderLineItemFields}
  fragment CartCustomerFields on Customer {
    id
    defaultAddress {
      ...ShopifyMailingAddressFields
    }
    addresses(first: 100) {
      edges {
        node {
          ...ShopifyMailingAddressFields
        }
      }
    }
    displayName
    firstName
    lastName
    email
    phone
    orders(first: 100, sortKey: PROCESSED_AT, reverse: true) {
      edges {
        node {
          id
          discountApplications(first: 100) {
            edges {
              node {
                ...CheckoutDiscountFields
              }
            }
          }
          lineItems(first: 100) {
            edges {
              node {
                ...OrderLineItemFields
              }
            }
          }
          orderNumber
          processedAt
          successfulFulfillments {
            trackingCompany
            trackingInfo {
              number
              url
            }
          }
          subtotalPriceV2 {
            ...ShopifyMoneyV2Fields
          }
          totalTaxV2 {
            ...ShopifyMoneyV2Fields
          }
          totalShippingPriceV2 {
            ...ShopifyMoneyV2Fields
          }
          totalPriceV2 {
            ...ShopifyMoneyV2Fields
          }
        }
      }
    }
  }
`

export const CartBuyerIdentityFields = gql`
  ${CartCustomerFields}
  fragment CartBuyerIdentityFields on CartBuyerIdentity {
    countryCode
    email
    phone
    customer {
      ...CartCustomerFields
    }
  }
`

export const CartInputFields = gql`
  ${CartCustomerFields}
  ${CartBuyerIdentityFields}
  ${ShopifyMailingAddressFields}
  ${CartLineInputFields}
  fragment CartInputFields on CartInput {
    note
    giftCardCodes
    attributes {
      key
      value
    }
    buyerIdentity {
      ...CartBuyerIdentityFields
    }
    delivery {
      addresses {
        ...ShopifyMailingAddressFields
      }
    }
    discountCodes {
      code
      applicable
    }
    lines(first: 100) {
      edges {
        node {
          ...CartLineInputFields
        }
      }
    }
  }
`

export const CartFields = gql`
  ${BaseCartLineFields}
  ${ShopifyMoneyV2Fields}
  ${CartBuyerIdentityFields}
  fragment CartFields on Cart {
    id
    note
    checkoutUrl
    updatedAt
    createdAt
    totalQuantity
    lines(first: 100) {
      edges {
        node {
          ...BaseCartLineFields
        }
      }
    }
    buyerIdentity {
      ...CartBuyerIdentityFields
    }

    discountCodes {
      code
      applicable
    }

    cost {
      subtotalAmountEstimated
      totalAmountEstimated
      checkoutChargeAmount {
        ...ShopifyMoneyV2Fields
      }
      subtotalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalTaxAmount {
        ...ShopifyMoneyV2Fields
      }
    }
  }
`

export const CustomerFields = gql`
  ${ShopifyMoneyV2Fields}
  ${ShopifyMailingAddressFields}
  ${CheckoutDiscountFields}
  ${CartFields}
  ${OrderLineItemFields}
  fragment CustomerFields on Customer {
    id
    defaultAddress {
      ...ShopifyMailingAddressFields
    }
    addresses(first: 100) {
      edges {
        node {
          ...ShopifyMailingAddressFields
        }
      }
    }
    displayName
    firstName
    lastName
    email
    phone
    lastIncompleteCheckout {
      ...CheckoutFields
    }
    orders(first: 100, sortKey: PROCESSED_AT, reverse: true) {
      edges {
        node {
          id
          discountApplications(first: 100) {
            edges {
              node {
                ...CheckoutDiscountFields
              }
            }
          }
          lineItems(first: 100) {
            edges {
              node {
                ...OrderLineItemFields
              }
            }
          }
          orderNumber
          processedAt
          successfulFulfillments {
            trackingCompany
            trackingInfo {
              number
              url
            }
          }
          subtotalPriceV2 {
            ...ShopifyMoneyV2Fields
          }
          totalTaxV2 {
            ...ShopifyMoneyV2Fields
          }
          totalShippingPriceV2 {
            ...ShopifyMoneyV2Fields
          }
          totalPriceV2 {
            ...ShopifyMoneyV2Fields
          }
        }
      }
    }
  }
`
